import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filterArrayByProperty' })
export class FilterArrayByPropertyPipe implements PipeTransform {
  transform<T extends Record<string, any>>(items: T[], propName: keyof T, expectedValue: any): T[] {
    if (!items || !Array.isArray(items) || items.length === 0 || !propName) {
      return items;
    }

    return items.filter(item => {
      const value = item[propName];

      if (typeof value === 'function') {
        return value() === expectedValue;
      } else {
        return !!value ? value === expectedValue : true;
      }
    });
  }
}
